export const validation = {
  replyRequired: 'replay is required',
  postImage: 'Image is required',
  description: 'Description is required',
  validUrl: 'Please enter valid url',
  url: 'Url is required',
};
